"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_apexcharts_1 = __importDefault(require("react-apexcharts"));
const PlateChart_1 = require("../components/PlateChart");
const api_1 = require("@app/api");
const chartsCommon_1 = require("@app/routes/Dashboard/chartsCommon");
const locale_1 = __importDefault(require("../locale"));
const CategoryHalfDonutsPopup_1 = __importDefault(require("@app/routes/Dashboard/components/CategoryHalfDonutsPopup"));
const useChartCustomTooltip_1 = require("@app/routes/Dashboard/hooks/useChartCustomTooltip");
const useTargetExerciseContext_1 = require("@app/routes/Dashboard/hooks/useTargetExerciseContext");
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const ModulesRound = () => {
    const [avgModules, setAvgModules] = (0, react_1.useState)();
    const [selectedDate, setSelectedDate] = (0, react_1.useState)((new Date()).toISOString().substr(0, 10));
    const { openTooltip, closeTooltip, tooltipState } = (0, useChartCustomTooltip_1.useChartCustomTooltip)({ initState: {} });
    const { setTargetExercise } = (0, useTargetExerciseContext_1.useTargetExerciseContext)();
    const { filterState } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    (0, react_1.useEffect)(() => {
        setSelectedDate(filterState.toDate);
    }, [filterState.toDate, filterState.fromDate]);
    (0, react_1.useEffect)(() => {
        // @ts-ignore
        api_1.ApiService.apiChartsAvgModulesList(selectedDate, selectedDate, undefined, userId)
            .then(response => setAvgModules(response));
    }, [selectedDate]);
    const avgModulesState = {
        // @ts-ignore
        series: avgModules === null || avgModules === void 0 ? void 0 : avgModules.map(e => e.percent),
        options: {
            // @ts-ignore
            labels: avgModules === null || avgModules === void 0 ? void 0 : avgModules.map(e => e.name),
            title: {
                text: locale_1.default.byModules,
                style: chartsCommon_1.titleStyle
            },
            legend: {
                fontSize: '10px',
                markers: {
                    width: 8,
                    height: 8
                },
                //floating: true,
                offsetX: 70,
                offsetY: 30,
            },
            plotOptions: {
                pie: {
                    customScale: 1,
                    offsetX: -40,
                }
            },
            chart: {
                events: {
                    dataPointSelection: (e, chart, options) => {
                        var _a, _b, _c;
                        const { dataPointIndex } = options;
                        const { clientX, clientY } = ((_c = (_b = (_a = chart === null || chart === void 0 ? void 0 : chart.series) === null || _a === void 0 ? void 0 : _a.ctx) === null || _b === void 0 ? void 0 : _b.events.w) === null || _c === void 0 ? void 0 : _c.globals) || {};
                        openTooltip({
                            params: {
                                clientX,
                                clientY,
                                dataPointIndex
                            }
                        });
                    }
                }
            },
            /*tooltip: {
              custom: ({ series, seriesIndex, dataPointIndex }) => {
                return '<div><a>exercise 1 </a></div>'
              }
            },*/
            stroke: {
            //colors: ['#fff']
            },
            fill: {
            //opacity: 0.8
            },
            responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 400
                        }
                    }
                }]
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PlateChart_1.PlateChart, { w: "38%", h: "225px", align: "center" },
            react_1.default.createElement("input", { type: "date", className: "chart-select input-date", name: "modulesRoundDate", id: "modulesRoundDate", style: { right: '14px' }, onChange: ev => setSelectedDate(ev.target.value), value: selectedDate, min: filterState.fromDate, max: filterState.toDate }),
            avgModules && react_1.default.createElement(react_apexcharts_1.default, { options: avgModulesState.options, series: avgModulesState.series, type: "polarArea", width: "400px", height: '200px' })),
        tooltipState.show && (react_1.default.createElement(CategoryHalfDonutsPopup_1.default, { ev: tooltipState, data: avgModules, closePopup: closeTooltip, setTargetExercise: setTargetExercise }))));
};
exports.default = ModulesRound;
